import React from 'react'
import styles from './styles/ProgressView.module.scss'

interface ProgressProps {
    progress: number;
}

const ProgressView: React.FC<ProgressProps> = (props: ProgressProps): React.ReactElement => {
    const {progress} = props

    return (
        <div className={styles.ProgressView}>
            <div
                className={styles.progressBar}
                style={
                    {width: `${progress}%`}
                }
            />
        </div>
    )
}

export default ProgressView
